import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../public/fonts/averta-regular-webfont.woff2%22,%22weight%22:%22400%22,%22style%22:%22normal%22,%22variable%22:%22--font-averta-regular%22}],%22variableName%22:%22avertaRegular%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'avertaRegular', 'avertaRegular Fallback'",
        fontWeight: 400,
fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
